var map = {
	"./help-black-text.svg": "./src/common/assets/icons/help-black-text.svg",
	"./help-white-text.svg": "./src/common/assets/icons/help-white-text.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/common/assets/icons sync recursive ^\\.\\/help\\-.*\\-text\\.svg$";